var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"exit","transform":"translate(-282 -83)"},[React.createElement("rect",{"id":"Rectangle_330","data-name":"Rectangle 330","width":"40","height":"40","transform":"translate(282 83)","fill":"#f0edeb","opacity":"0","key":0}),React.createElement("g",{"id":"exit-2","data-name":"exit","transform":"translate(290 91)","key":1},[React.createElement("line",{"id":"Line_556","data-name":"Line 556","x2":"14","y2":"14","transform":"translate(4 5)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Line_557","data-name":"Line 557","y1":"14","x2":"14","transform":"translate(4 5)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":1})])]));
}

Exit.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Exit;

Exit.default = Exit;
